import React, { Component } from 'react';
import utilFunction from '../../../containers/function';
import LineChart from '../graphs/crossfilterGraphs/lineChart';
import WorkdayChart from '../graphs/crossfilterGraphs/workdayChart';

const DriverWorkshiftsGraph = props => {
  return (
    <div id="driver-workshifts-graph" className="dc-chart-parent">
      {props.nfa && (
        <section className="help-component circular-driver">
          <section className="box-help">
            <i className="fas fa-question-circle" />
            <section className="box">
              {props.language.detail_fatigue.nfa.nfaText}
              <ul>
                <li>
                  <strong className="green">NFA1</strong>: {props.language.detail_fatigue.nfa.percentageOfNfaOne}
                </li>
                <li>
                  <strong className="yellow">NFA2</strong>: {props.language.detail_fatigue.nfa.percentageOfNfaTwo}
                </li>
                <li>
                  <strong className="orange">NFA3</strong>: {props.language.detail_fatigue.nfa.percentageOfNfaThree}
                </li>
                <li>
                  <strong className="red">NFA4</strong>: {props.language.detail_fatigue.nfa.percentageOfNfaFour}
                </li>
              </ul>
            </section>
          </section>
        </section>
      )}
      <WorkdayChart
        id={'driver-workshifts-graph-component'}
        language={props.language}
        additionalCrossfilterData={null}
        crossfilerData={utilFunction.generateCrossfilter(props.data)}
        stack={false}
        dimension={{
          formatFunction: [],
          name: 'date',
          originalName: 'date',
          reduceFunction: { type: 'CONTINUOUS_GROUP', typeof: 'DATE_TIME' }
        }}
        metrics={[]}
        config={{
          tooltip: {
            valuesConfig: [
              {
                identifier: 'type',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.activity
                }:</span> %v</div>`
              },
              {
                identifier: 'length',
                valueFormat: { type: 'NUMBER', format: 'hh:mm' },
                wrapper: `<div style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.duration
                }:</span> %v</div>`
              },
              {
                identifier: 'startDate',
                valueFormat: { type: 'DATE_TIME_UTC', format: '%I:%M %p' },
                wrapper: `<div style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.start
                }:</span> %v</div>`
              },
              {
                identifier: 'endDate',
                valueFormat: { type: 'DATE_TIME_UTC', format: '%I:%M %p' },
                wrapper: `<div style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.end
                }:</span> %v</div>`
              },
              {
                identifier: 'place',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.place
                }:</span> %v</div>`
              }
            ]
          },
          eventsCol: {
            type: 'activity',
            start: 'startHour',
            length: 'duration',
            lane: 'date',
            zIndex: 'priority',
            isStart: 'startFlag',
            isEnd: 'endFlag',
            place: 'site'
          },
          eventsLabels: [
            { type: 'Shift', label: 'Turno', level: 0 },
            { type: 'Conduction', label: `${props.graphLabels.driving}`, level: 1 },
            { type: 'Stopped', label: `${props.graphLabels.detention}`, level: 1 },
            { type: 'principal Base', label: `${props.graphLabels.base}`, level: 1 },
            { type: 'operation', label: `${props.graphLabels.client}`, level: 1 }
          ],
          valueFormat: { type: 'DATE_TIME', format: props.language.account.date.graphFormatXAxis },
          colors: [
            '#CCC',
            '#95C2FB',
            '#C9D1DE',
            '#A8C7CA',
            '#DCC6EA',
            '#E07B91',
            '#11C638',
            '#8DD593',
            '#C6DEC7',
            '#EAD3C6',
            '#F0B98D',
            '#EF9708'
          ],
          levelsNames: { '1': 'Actividades' },
          hoursCol: { show: true, eventsToSum: ['Shift'] },
          extraIndicatorCol: {
            show: props.nfa ? true : false,
            type: 'roadWarningCount',
            title: 'NFA',
            valueFormat: { type: 'NUMBER', format: '.0f' },
            fontSize: '16px',
            colorRange: [
              { color: '#41C99F', range: [{ value: 2, operator: '<' }] },
              {
                color: '#F3B119',
                range: [{ value: 2, operator: '>=' }, { value: 3, operator: '<' }]
              },
              { color: '#CC5660', range: [{ value: 3, operator: '>=' }] }
            ]
          }
        }}
        dashboardId={'driver_fatigue'}
      />
    </div>
  );
};
export default DriverWorkshiftsGraph;



// WEBPACK FOOTER //
// ./source/client/components/common/fatigue/driverWorkshiftsGraph.jsx